import { CreateActiveRedirectURLDto, IRedirectURLResp2Dto, UpdateRedirectURLDto } from 'src/types/redirect-url.type'
import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { IMessageResponseDto } from 'src/types'

class RedirectURLsService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getRedirectURLs(params?: {}) {
    const temp = this.get<IRedirectURLResp2Dto>('redirect-urls', {params})
    return temp
  }

  updateRedirectURL(id: string, dto: UpdateRedirectURLDto) {
    return this.put<IMessageResponseDto, UpdateRedirectURLDto>(`redirect-urls/${id}`, dto)
  }

  deleteRedirectURL(id: string) {
    return this.delete(`redirect-urls/${id}`)
  }

  createRedirectUrl(dto: CreateActiveRedirectURLDto) {
    return this.post(`redirect-urls/create`, dto)
  }

  changeActiveRedirectURL(id: string) {
    return this.get(`redirect-urls/change-active/${id}`)
  }
}

export const redirectURLsService = new RedirectURLsService()
export default RedirectURLsService
